import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export interface OnAddinPictureDeletedActionMessage {
    composeId: string;
    pictureIds: string[];
    mailboxInfo: MailboxInfo;
    targetWindow: Window;
}

const onAddinPictureDeleted: (
    composeId: string,
    pictureIds: string[],
    mailboxInfo: MailboxInfo,
    targetWindow: Window
) => OnAddinPictureDeletedActionMessage = action(
    'OnAddinPictureDeleted',
    (
        composeId: string,
        pictureIds: string[],
        mailboxInfo: MailboxInfo,
        targetWindow: Window
    ): OnAddinPictureDeletedActionMessage => ({
        composeId,
        pictureIds,
        mailboxInfo,
        targetWindow,
    })
);

export default onAddinPictureDeleted;
